// **api接口的统一出口**

// 首页接口
import index from './api/index.js';
// 业务接口
import bus from './api/bus.js';
// 授权接口
import grant from './api/grant.js';
// 用户接口
import user from './api/user.js';
// 订单接口
import members from './api/members.js'

// 导出接口
export default {
    index,
    bus,
    grant,
    user,
    members
}



// WEBPACK FOOTER //
// ./src/utils/api.js